import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return [];
  }


  initialize(){

  }

  reload(e) {
  
   this.loadPage(e)
  } 



  loadPage(e) {
    let div =  document.createElement('div' )
    div.style.position = 'absolute';
    div.style.top = 0;
    div.style.left =0;
    div.style.width = '100%';
    div.style.height = '100%';
    div.style.zIndex = 20; 
    div.style.backgroundColor = 'black'; 
    div.style.opacity = '0.3';
    this.element.after(div)
    let base = window.location.href
    if (!/vendor_orders\/new/.test(base)){
      base = base += '/new'
    }
    let url = new URL(base)
    let p = new URLSearchParams({outlook_weeks: e.target.value } ) 
    url.search = p.toString()
    Turbolinks.visit(url);
  }


}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/vendor_week_outlook_controller.js